var map = {
	"./Arrow_Swipe_Left.png": 29894,
	"./Arrow_Swipe_Right.png": 85915,
	"./Brightness_Star.png": 83144,
	"./Button_Done_Tick.png": 64579,
	"./Create_Plus.png": 84959,
	"./Delete_Event.png": 91342,
	"./Keyboard_Bar_Cross.png": 45434,
	"./Keyboard_Bar_Tick.png": 72503,
	"./Map_Directions.png": 89669,
	"./Map_Pin.png": 83418,
	"./Map_Search.png": 20835,
	"./Map_Share.png": 54822,
	"./Month_Expand_Button.png": 95568,
	"./Plus.png": 77214,
	"./Return_Arrow.png": 18838,
	"./Swipe_Up_Arrow.png": 24902,
	"./Themes_Float.png": 23943,
	"./Themes_List.png": 29453,
	"./actions_to_timepage.png": 36528,
	"./add_new_event_widget.webp": 53349,
	"./countdown_anniversary.png": 62654,
	"./countdown_birthday.png": 41889,
	"./countdown_earnest.png": 78170,
	"./countdown_event.png": 63012,
	"./countdown_open.png": 94618,
	"./countdown_siri_1.png": 49437,
	"./countdown_siri_2.png": 65670,
	"./countdown_siri_3.png": 50767,
	"./countdown_web.png": 89142,
	"./countdown_widget.webp": 73495,
	"./countdown_widget_collapsed.png": 2208,
	"./countdown_widget_expanded.png": 86472,
	"./countdown_widget_medium.png": 33734,
	"./date_widget.webp": 41156,
	"./day_widget.webp": 49700,
	"./heatmap_widget.webp": 50198,
	"./iPad-Left-sm@2x.jpg": 69431,
	"./iPad-Left.jpg": 7574,
	"./month_widget.webp": 59460,
	"./slide_complete.png": 9481,
	"./slide_delete_on.png": 21633,
	"./slide_schedule_off.png": 49813,
	"./this_day_in_history_widget.webp": 88396,
	"./time_widget.webp": 97767,
	"./timepage_to_actions.png": 21674,
	"./today_widget.webp": 53093,
	"./travel_time_widget.webp": 51306,
	"./upcoming_event_widget.webp": 45635,
	"./weather_widget.webp": 606,
	"./widgets.png": 61059
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28093;